import React from 'react';
import { Link } from 'react-router-dom';
import useLanguage from '../../hooks/useLanguage';
import Card from '../common/Card';
import Button from '../common/Button';
import translationsData from '../../data/translations.json';

/**
 * ProductCard Component
 * Displays individual product information with image, name, category, and description
 * Links to product detail page on click
 */
const ProductCard = ({ product }) => {
  const { language } = useLanguage();

  const productName = language === 'ko' ? product.name : product.nameEn;
  const productCategory = language === 'ko' ? product.category : product.categoryEn;
  const productDescription = language === 'ko' ? product.shortDescription : product.shortDescriptionEn;
  const viewDetailsBtn = language === 'ko' ? translationsData.buttons.viewDetails : translationsData.buttons.viewDetailsEn;

  return (
    <Card className="h-full flex flex-col hover:shadow-2xl hover:scale-105 transition-all duration-300">
      {/* Product Image */}
      <div className="relative w-full h-48 md:h-56 overflow-hidden rounded-t-lg">
        <img
          src={product.image}
          alt={productName}
          className="w-full h-full object-cover"
        />
        {/* Category Badge */}
        <div className="absolute top-4 left-4 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-semibold shadow-md">
          {productCategory}
        </div>
      </div>

      {/* Product Info */}
      <div className="p-6 flex-1 flex flex-col">
        {/* Product Name */}
        <h3 className="text-xl font-semibold text-gray-900 mb-3">
          {productName}
        </h3>

        {/* Product Description */}
        <p className="text-gray-600 line-clamp-2 flex-1 mb-4">
          {productDescription}
        </p>

        {/* View Details Button */}
        <Link to={`/products/${product.id}`} className="mt-auto">
          <Button variant="outline" size="md" className="w-full">
            {viewDetailsBtn}
          </Button>
        </Link>
      </div>
    </Card>
  );
};

export default ProductCard;
